module.exports = __webpack_public_path__ + "img/thumb-up.c3cb5c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumb-up.jpg
// module id = hexe
// module chunks = 1